<template>
  <div id="contenedor" class="algo">
    <v-layout row justify-center :align-center="!isMobileOrTablet" :class="{ 'mobile-layout': isMobileOrTablet }" fill-height>
      <v-flex xs12 sm10 md8 lg6>
        <v-card class="table" elevation="4">
          <v-toolbar flat elevation="4">
            <v-card class="icon">
              <v-icon
                style="margin-left: 30px; margin-top: 25px"
                color="white"
                x-large=""
                >mdi-alert-plus</v-icon
              >
            </v-card>
            <div class="usuario">NUEVO TICKET</div>
          </v-toolbar>
          <v-container grid-list-md class="responsive-container">
            <v-layout wrap>
              <v-flex xs12 sm6 md6>
                <v-autocomplete
                  color="#1D3C7F"
                  persistent-hint
                  v-model="editedItem.requerimientos"
                  label="Requerimiento"
                  :items="todosRequerimientos"
                  item-value="cc_id_requerimientos"
                  :item-text="item => item.cc_nombre_requerimiento_con_empresa || item.cc_nombre_requerimiento"
                  @change="handleRequerimiento()"
                >
                  <template v-slot:item="{ item }">
                    <v-list-item-content>
                      <v-list-item-title>{{ item.cc_nombre_requerimiento }}</v-list-item-title>
                      <v-list-item-subtitle v-if="item.nombreEmpresa">
                        <strong>{{ item.nombreEmpresa }}</strong>
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </template>
                  <template v-slot:selection="{ item }">
                    <span>{{ item.cc_nombre_requerimiento }} <strong v-if="item.nombreEmpresa">({{ item.nombreEmpresa }})</strong></span>
                  </template>
                </v-autocomplete>
              </v-flex>
              <v-flex xs12 sm6 md6>
                <v-text-field
                  v-model="disabledArea"
                  label="Area"
                  :disabled="true"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm12 md12 class="text-center">
                <v-btn
                  class="ma-2"
                  outlined
                  color="#1D3C7F"
                  :disabled="!editedItem.requerimientos || !editedItem.idArea || loading"
                  dark @click="crearChat()"
                  >Subir Caso
                  <v-progress-circular
                    v-if="loading"
                    indeterminate
                    color="primary"
                    size="50"
                    class="loader-outside-button"
                  ></v-progress-circular>
                </v-btn
                >
              </v-flex>
            </v-layout>
          </v-container>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import axios from "axios";
import env from "../../env";
import store from "../../../store/casosStore";
export default {
  data() {
    return {
      loading: false,
      text: "",
      search: "",
      disabledArea: "",
      areas: [
        {
          idArea: "1",
          area: "MESA DE SERVICIO",
        },
        {
          idArea: "2",
          area: "SISTEMAS",
        },
        {
          idArea: "3",
          area: "GESTION HUMANA",
        },
        {
          idArea: "4",
          area: "CARTERA",
        },
        {
          idArea: "5",
          area: "SEGURIDAD Y RECAUDO",
        },
        {
          idArea: "6",
          area: "JURIDICA",
        },
        {
          idArea: "7",
          area: "CONTROL INTERNO",
        },
        {
          idArea: "8",
          area: "ANALISTA DE DATOS",
        },
        {
          idArea: "9",
          area: "JUEGOS LOCALIZADOS",
        },
        {
          idArea: "10",
          area: "BETPLAY",
        },
        {
          idArea: "11",
          area: "LOGISTICA",
        },
        {
          idArea: "12",
          area: "MANTENIMIENTO",
        },
        {
          idArea: "14",
          area: "ANALITICA",
        },
        {
          idArea: "15",
          area: "ADMINISTRATIVA",
        },
        {
          idArea: "16",
          area: "CUMPLIMIENTO",
        },
        {
          idArea: "18",
          area: "SERVICIO AL CLIENTE",
        },
      ],
      requerimientos: [],
      todosRequerimientos: [],
      id: localStorage.getItem("id"),
      editedItem: {
        requerimientos: "",
        idArea: "",
      },
    };
  },

  mounted() {
    this.obtenerTodo();
    localStorage.removeItem("sala");
    localStorage.removeItem("requerimiento");
  },
  methods: {
    guardarRequerimiento(requerimiento = "", sala = "") {
      // Dispatch the action to save the requerimiento
      store.dispatch("setRequerimiento", requerimiento);
      store.dispatch("setSala", sala);
    },
    obtenerTodo() {
      const idEmpresaUsuario = localStorage.getItem("idEmpresa");
      axios
        .get(`${env.endpoint}callcenter/requerimientostodos?idUsuario=${this.id}`)
        .then(({ data }) => {
          this.todosRequerimientos = [];
          data.map( item => {
            // Usar cc_id_area_requerimiento en lugar de cc_id_area
            const existsArea = this.areas.find( area => area.idArea == item.cc_id_area_requerimiento );
            
            if ( existsArea ) {
              // 🆕 FILTRO: Ocultar requerimientos de Desenrolamiento/Huella para TODOS (Apostar y Facilisimo)
              // EXCEPTO BETPLAY (ID 30), para forzar el uso del módulo de la huellita (RegistroHuella.vue).
              const nombre = item.cc_nombre_requerimiento.toUpperCase();
              // const esApostar = (item.idEmpresa == 2 || item.nombreEmpresa == 'Apostar');
              const esDesenrolamiento = nombre.includes("DESENROLAMIENTO") || nombre.includes("DESENRROLAMIENTO") || nombre.includes("HUELLA");
              const esBetplay = item.cc_id_requerimientos == 30; // Betplay se maneja en formulario tradicional
              const esDesenrolamientoSuperflex = item.cc_id_requerimientos == 190 && idEmpresaUsuario == 1; // Desenrolamiento Cliente Superflex

              if (esDesenrolamiento && !esBetplay && !esDesenrolamientoSuperflex) {
                // Omitir este requerimiento (va a FormCasos)
                return;
              }

              this.todosRequerimientos.push( item );
            }
          });
        });
    },
    async crearChat() {
      let idAsesor = "";
      if (this.editedItem.requerimientos === "") {
      } else {
        this.loading = true;
        localStorage.removeItem("sala");
        localStorage.removeItem("requerimiento");
        
        // CAMBIO: Todos los usuarios deben seleccionar punto de venta manualmente
        // Se eliminó la detección automática por IP - el usuario DEBE seleccionar el punto
        
        /* CÓDIGO ANTERIOR COMENTADO - Por si se necesita después
        // Obtener idPunto antes de crear el caso
        // El backend espera idPunto en el objeto caso para guardarlo en el campo "ip"
        // Si la IP ya tiene un punto asociado, lo obtenemos de validarPunto
        // Si no tiene punto asociado, se envía null y el backend usará la IP real como fallback
        let idPunto = null;
        try {
          const validarPunto = await axios.get(`${env.endpoint}callcenter/validarPunto`);
          // Si validarPunto devuelve estado: true, la IP ya tiene un punto asociado
          if (validarPunto.data.estado) {
            // Obtener el idPunto de la respuesta (puede venir en diferentes formatos)
            idPunto = validarPunto.data.idPunto || validarPunto.data.id_punto || validarPunto.data.punto || null;
          }
        } catch (error) {
          // Si hay error al validar, enviar null (backend usará IP como fallback)
          console.error('Error al validar punto:', error);
        }
        */
        
        // NUEVO: El usuario DEBE seleccionar el punto manualmente en Chat.vue
        // Se envía null y el backend usará la IP real como fallback
        // El punto se actualizará cuando el usuario lo seleccione en el chat
        const idPunto = null;
        
        const caso = JSON.stringify({
          idUsuario: this.id,
          requerimientos: this.editedItem.requerimientos,
          idArea: this.editedItem.idArea,
          idPunto: idPunto, // Siempre null - el usuario seleccionará el punto en Chat.vue
        });
        // se sube el caso y crea el chats
        axios.get(`${env.endpoint}callcenter/iniciar_caso?caso=${caso}`)
        .then((res) => {
          idAsesor = res.data.cc_id_asesor;
          this.guardarRequerimiento(
            res.data.cc_id_requerimiento,
            res.data.cc_id_caso
            );
            localStorage.setItem(
              "requerimiento",
              res.data.cc_id_requerimiento
              );
              localStorage.setItem("sala", res.data.cc_id_caso);

              axios.post(`${env.endpoint}historial/registrar_accion`, {
                  cc_id_caso: res.data.cc_id_caso,
                  accion: 1, // 1 = Caso creado (según tu modelo)
                  idUsuario: this.id,
                  observaciones: "" // O algún texto si lo tienes
          });


              if( idAsesor !== localStorage.getItem("id") ) {
                localStorage.clear();
                window.location.reload();
              } else this.$router.push("/Callcenter/Asesor/chat");
              this.loading = false;
            })
            .catch((error) => {
              // En caso de error, también deshabilitar el loader
              this.loading = false;
              console.error(error);
            });

            
          }
        },
        handleRequerimiento() {

          const area = this.todosRequerimientos.find( req => req.cc_id_requerimientos === this.editedItem.requerimientos );

          if ( area ) {
            this.editedItem.idArea = area.cc_id_area;
  
            this.disabledArea = area.cc_nombre_area;
  
          }
        },
  },
  computed: {
    isMobileOrTablet() {
      return this.$vuetify.breakpoint.xs || this.$vuetify.breakpoint.sm || this.$vuetify.breakpoint.md || this.$vuetify.breakpoint.lg;
    }
  },
};
</script>

<style scoped>
  .loader-outside-button {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 2; /* Ajusta según sea necesario para estar por encima del botón */
  }

  .responsive-container {
    margin-top: 50px;
  }

  #contenedor {
  min-height: calc(100vh - 48px); /* Adjust for toolbar height */
}

.mobile-layout {
  padding-top: 15vh !important;
  align-items: flex-start !important;
}

@media (max-width: 600px) {
  .responsive-container {
    margin-top: 20px;
    padding: 16px 8px;
  }
  
  #contenedor {
    padding: 8px;
    min-height: calc(100vh - 48px);
  }
  
  .mobile-layout {
    padding-top: 20vh !important;
  }
}

@media (min-width: 600px) and (max-width: 960px) {
  .responsive-container {
    margin-top: 30px;
    padding: 24px 16px;
  }
  
  #contenedor {
    padding: 16px;
    min-height: calc(100vh - 48px);
  }
  
  .mobile-layout {
    padding-top: 15vh !important;
  }
}

@media (min-width: 960px) and (max-width: 1263px) {
  .responsive-container {
    margin-top: 35px;
    padding: 20px 16px;
  }
  
  #contenedor {
    padding: 20px;
    min-height: calc(100vh - 48px);
  }
  
  .mobile-layout {
    padding-top: 12vh !important;
  }
}

@media (min-width: 1264px) and (max-width: 1903px) {
  .responsive-container {
    margin-top: 40px;
    padding: 24px 20px;
  }
  
  #contenedor {
    padding: 24px;
    min-height: calc(100vh - 48px);
  }
  
  .mobile-layout {
    padding-top: 10vh !important;
  }
}

@media (min-width: 1904px) {
  #contenedor {
    padding: 24px;
    min-height: calc(100vh - 48px);
  }
}
</style>
